import { MdOutlineExtension as _MdOutlineExtension } from "@react-icons/all-files/md/MdOutlineExtension.js";
import React from 'react';
import { Box, Card, Flex, Grid, Tag, Text } from 'core/components';
import { useTheme } from 'styled-components';
import AddOnCardExtensions from './AddOnCardExtensions';
const AddOnCard = ({
  title,
  description,
  extensions = [],
  zIndex
}) => {
  const theme = useTheme();
  const isDarkMode = theme.name === 'dark';
  const contentColor = isDarkMode ? theme.colors.whiteMuted : theme.colors.muted;
  return /*#__PURE__*/React.createElement(Card, {
    p: 2,
    pt: 4,
    bg: theme.colors.sectionBackground,
    borderRadius: 8,
    mt: "-16px",
    position: "relative",
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement(Grid, {
    gridTemplateColumns: "2fr 1fr",
    gridTemplateRows: "1fr"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    mr: 3,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(_MdOutlineExtension, {
    size: 20,
    color: theme.colors.primary
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 1
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    color: contentColor,
    fontWeight: 500
  }, title), /*#__PURE__*/React.createElement(Tag, {
    ml: 1,
    color: contentColor,
    fontSize: 12,
    p: "2px 6px",
    borderRadius: 4
  }, "Add-On")), /*#__PURE__*/React.createElement(Text, {
    as: "div",
    fontSize: 18,
    fontWeight: "bold"
  }, description)))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    mb: 1
  }, "Extensions"), /*#__PURE__*/React.createElement(AddOnCardExtensions, {
    extensions: extensions
  }))));
};
export default AddOnCard;